<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header></Header>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb"><a href="/tw/">首頁</a><span class="space">/</span>攻略</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div guide_detail_box">
			
			<h1>{{guideDetail.Title}}</h1>			
			<div class="guideContent" v-html="guideContent"></div>
			
		</div>		
		
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getGuideDetail
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import NoData from '@/components/tw_noData.vue'
	export default {
		name: 'TW_GuideDetail',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			NoData,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				Id: '', //当前id
				noDataIsShow: false, //无数据缺省
				guideDetail: {}, //详情
				
				guideContent: '',	//富文本详情
			}
		},
		created() {
			// 模拟获取url参数
			this.Id = this.$route.query.Id
			this.toDetail()
		},
		mounted() { //组件挂载到 DOM 后触发

		},
		methods: {			
			//查看详情
			async toDetail() {
				const {
					data: res
				} = await getGuideDetail(this.language, this.Id)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.guideDetail = res.data
					
					//热词替换
					this.guideContent = this.patchReplace(
					this.guideDetail.RecreationHotKeywords,
					this.guideDetail.Content,
					'/tw/recreation/detail?Id=')
					
					this.$nextTick(() => {
						window.scrollTo(0, 0);
					});
				} else {
					this.$message.error(res.errmsg);
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.guide_detail_box {
			margin-top: 40px;
			min-height: 650px;
			
			h1 {
				font-size: 28px;
				font-weight: 500;
				text-align: center;
				line-height: 160%;
			}
			
			.guideContent {
				width: 100%;
				font-size: 15px;
				line-height: 180%;
				margin: 40px 0;
				position: relative;
				overflow: hidden;
				
				/deep/ p,div {
					margin: 10px 0;
				}
				
				img {
					max-width: 100%;
				}
			}
			
		}
		
	}
</style>